import { createSlice } from '@reduxjs/toolkit'

export const statementHighlightPathsSlice = createSlice({
    name: 'statementHighlightPaths',
    initialState: {
        result: [],
    },
    reducers: {
        setStatementHighlightPaths: (state, action) => {
            state.result = action.payload;
        }
    },
})

export const { setStatementHighlightPaths } = statementHighlightPathsSlice.actions;

export const getStatementHighlightPaths = (state) => state.statementHighlightPaths.result;

export default statementHighlightPathsSlice.reducer